import React, { useContext, useState } from "react";
import { VerticalFlex } from "@vahak/core-ui/dist/layout/Flex";
import LineDivider from "@vahak/core-ui/dist/components/LineDivider";
import Checkbox, { CheckboxOnChangeHandler } from "@vahak/core-ui/dist/components/Checkbox";
import { GenericObject } from "@vahak/core-ui/dist/types";
import { AppContext } from "@vahak/core/dist/app-context";
import QuickActionPopup, { QuickActionPopupProps } from "../../../quick-action-popup/QuickActionPopup";

interface Props {
    popupProps?: Pick<QuickActionPopupProps, "isOpen" | "onToggle">;
}

const CsCustomPrefernce = ({ popupProps }: Props) => {
    const { globalData, setGlobalData } = useContext(AppContext);
    const onChangeCsPrefernce: CheckboxOnChangeHandler = (e) => {
        const result: GenericObject = {};
        if (e.target.name === "no-tag") {
            result["locationTags"] = e.target.checked ? [] : undefined;
        }
        setGlobalData?.(result);
    };

    return (
        <QuickActionPopup
            {...popupProps}
            titleText="Custom Prefernce"
            ctaText={"Close"}
            ctaAction={popupProps?.onToggle}
            description={
                <VerticalFlex gap={4} margin={"20px 0"}>
                    <Checkbox
                        id="no-tag"
                        label="No Location Tags"
                        name="no-tag"
                        onChange={onChangeCsPrefernce}
                        value={Array.isArray(globalData?.locationTags) && !globalData?.locationTags?.length}
                        alignItems="center"
                    />
                </VerticalFlex>
            }
        ></QuickActionPopup>
    );
};

export default CsCustomPrefernce;
